import {sumBy} from 'lodash';
import {StudentYear} from 'shared/application-management/selectors';
import {gradeLevelForGraduationYear, secondHalfOfSchoolYear} from 'shared/utils';
import {UserType} from 'src/types/enums';

export default class Student {
  data;
  courses;

  constructor(studentData, courses) {
    this.data = studentData;
    this.courses = courses;
  }

  get hsGraduationYear() {
    if (!this.data.highSchoolInfo) {
      return null;
    }

    return this.data.highSchoolInfo.graduationYear;
  }

  getGradeLevelFromYear = (year) => gradeLevelForGraduationYear(year);

  isHighSchoolStudent = () => this.data.educationPhase === UserType.HS_STUDENT;

  getCreditCount = () => {
    const courses = Object.values(this.courses || {});
    return sumBy(courses, (course) => (course.new ? 0 : course.credits));
  };
}

/**
 * True iff student is past second semester junior year AND iff student has more than 10 credits
 * @param student {Student}
 * @return boolean
 */
export const isUpperClassman = (student) => {
  if (student.isHighSchoolStudent()) {
    const gradeLevel = student.getGradeLevelFromYear(student.hsGraduationYear);
    const juniorSecondHalf = gradeLevel === StudentYear.JUNIOR && secondHalfOfSchoolYear();
    const senior = gradeLevel === StudentYear.SENIOR;
    const creditCount = student.getCreditCount();
    return (juniorSecondHalf || senior) && creditCount >= 10;
  }

  return false;
};
